import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { CClassTribIbsCbsStruct } from '../../../../../../shared/services/structs/motor-fiscal/c-class-trib-ibs-cbs.struct';
import { CstIbsCbsCclasstribIbsCbsStruct } from '../../../../../../shared/services/structs/motor-fiscal/cst-ibs-cbs-cclasstrib-ibs-cbs.struct';
import { FormulaCatalogoItemStruct } from '../../../../../../shared/services/structs/formula/formula-catalogo-item.struct';
import { CodigoCreditoPresumidoStruct } from '../../../../../../shared/services/structs/motor-fiscal/codigo-credito-presumido.struct';
import { LookupItemStruct } from '../../../../../../shared/services/structs/motor-fiscal/lookup-item.struct';
import { ModeloDocumento } from '../../../../../../shared/services/models/dfe/modelo-documento.model';
import { TabsScrollDirective } from '../../../../../../shared/directives/tabs-scroll.directive';
import { RegraTributariaIndicadoresUi } from '@shared/constants/motor-fiscal/regra-tributaria-indicadores.util';
import { RegraTributariaDadosGeraisTabComponent } from '../../tabs/regra-tributaria-dados-gerais-tab/regra-tributaria-dados-gerais-tab.component';
import { RegraTributariaIbsCbsTabComponent } from '../../tabs/regra-tributaria-ibs-cbs-tab/regra-tributaria-ibs-cbs-tab.component';
import { RegraTributariaTribRegularTabComponent } from '../../tabs/regra-tributaria-trib-regular-tab/regra-tributaria-trib-regular-tab.component';
import { RegraTributariaTribMonoTabComponent } from '../../tabs/regra-tributaria-trib-mono-tab/regra-tributaria-trib-mono-tab.component';
import { RegraTributariaCreditoPresumidoTabComponent } from '../../tabs/regra-tributaria-credito-presumido-tab/regra-tributaria-credito-presumido-tab.component';
import { RegraTributariaIsTabComponent } from '../../tabs/regra-tributaria-is-tab/regra-tributaria-is-tab.component';

/**
 * Etapa "Tributação" do cadastro de Regra Tributária: agrupa as 7 abas de tributos num mat-tab-group.
 * É a única etapa exibida no modo padrão (configuração de tributos) e a primeira no modo convencional.
 */
@Component({
    selector: 'app-regra-tributaria-tributacao-step',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatTabsModule,
        TabsScrollDirective,
        RegraTributariaDadosGeraisTabComponent,
        RegraTributariaIbsCbsTabComponent,
        RegraTributariaTribRegularTabComponent,
        RegraTributariaTribMonoTabComponent,
        RegraTributariaCreditoPresumidoTabComponent,
        RegraTributariaIsTabComponent,
    ],
    templateUrl: './regra-tributaria-tributacao-step.component.html',
    styleUrl: './regra-tributaria-tributacao-step.component.css',
})
export class RegraTributariaTributacaoStepComponent {
    @Input({ required: true }) form!: FormGroup;
    @Input() csts: CClassTribIbsCbsStruct[] = [];
    @Input() cclasstribs: CClassTribIbsCbsStruct[] = [];
    @Input() relacoes: CstIbsCbsCclasstribIbsCbsStruct[] = [];
    @Input() modelosDocumento: ModeloDocumento[] = [];
    @Input() isModoPadrao = false;
    @Input() indicadoresUi: RegraTributariaIndicadoresUi | null = null;

    @Input() formulasIbsCbs: FormulaCatalogoItemStruct[] = [];
    @Input() formulasCbs: FormulaCatalogoItemStruct[] = [];
    @Input() formulasIbsUf: FormulaCatalogoItemStruct[] = [];
    @Input() formulasIbsMunicipio: FormulaCatalogoItemStruct[] = [];
    @Input() formulasTribRegular: FormulaCatalogoItemStruct[] = [];
    @Input() formulasMonoPadrao: FormulaCatalogoItemStruct[] = [];
    @Input() formulasMonoRetencao: FormulaCatalogoItemStruct[] = [];
    @Input() formulasMonoRetida: FormulaCatalogoItemStruct[] = [];
    @Input() formulasMonoDiferimento: FormulaCatalogoItemStruct[] = [];
    @Input() formulasCreditoPresumidoOperacao: FormulaCatalogoItemStruct[] = [];
    @Input() formulasCreditoPresumidoIbs: FormulaCatalogoItemStruct[] = [];
    @Input() formulasCreditoPresumidoCbs: FormulaCatalogoItemStruct[] = [];
    @Input() formulasRegra: FormulaCatalogoItemStruct[] = [];
    @Input() codigosCreditoPresumido: CodigoCreditoPresumidoStruct[] = [];
    @Input() indicadoresDoacao: LookupItemStruct[] = [];

    public selectedTabIndex = 0;

    /** Retorna true se algum dos controles/grupos indicados está inválido (indicador de aba com pendência). */
    public isAbaInvalida(...caminhos: string[]): boolean {
        return caminhos.some(caminho => this.form.get(caminho)?.invalid ?? false);
    }
}
